import { TValidationScheme } from '@krugom/validator/dist/types';
import { isFunction, isPlainObject } from 'lodash';

export const requestParamsSchema: TValidationScheme = {
  type: 'object',
  properties: {
    key: { type: 'string' },
    path: { type: 'string' },
    method: { type: 'string', pattern: /^(GET)|(POST)|(PUT)|(DELETE)$/ },
    query: { type: 'custom', validator: (v: unknown) => isPlainObject(v) },
    body: { type: 'custom', validator: (v: unknown) => isPlainObject(v) },
    headers: { type: 'custom', validator: (v: unknown) => isPlainObject(v) },
    force: { type: 'boolean' },
    submitOnLoad: { type: 'boolean' },
    onSucceed: { type: 'custom', validator: (v: unknown) => isFunction(v) },
    onRejected: { type: 'custom', validator: (v: unknown) => isFunction(v) },
  },
};
